import {Component, Input, OnInit} from '@angular/core';
import {SearchPropertyModel} from '../../models/properties/properties.models';
import {PropertyType} from '../../enums/property.enums';

@Component({
  selector: 'app-property-card',
  templateUrl: './property-card.component.html',
  styleUrls: ['./property-card.component.scss']
})
export class PropertyCardComponent implements OnInit {

  @Input() details: SearchPropertyModel;
  @Input() url: string;

  constructor() { }

  ngOnInit(): void {
  }

  isLandProperty(): boolean {
    const landPropertyIds = [PropertyType.LAND, PropertyType.LAND_COMMERCIAL, PropertyType.FARM_LAND];
    return landPropertyIds.includes(Number(this.details?.propertyType));
  }

  getUrl(): string {
    if (this.details?.id) {
      return this.url
        ? `${this.url}/${this.details.id}`
        : `/properties/details/${this.details.id}`;
    } else {
      return '#';
    }
  }
}
